module.exports = {"IIN":"ИИН","FullName":"ФИО"};